
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
const comForm = () => import("./comForm.vue"); //子组件引用父组件使用异步方式加载引入
import { customModal } from "@newview/ui";
import dynamicForm from "@newview/ui/src/components/dynamic-form.vue";
import JSONEditor from "jsoneditor";
@Component({
  name: "JsonEdit",
  components: {
    dynamicForm,
    customModal,
    comForm,
  },
})
export default class JsonEdit extends BaseVue {
  //#region params
  editor;
  @Prop({ default: () => [] }) JsonData!: any; //搜索条件配置参数
  jsonEditBoxId = "jsoneditor_" + this.NewGuid();
  @Prop({ default: false }) DataStruct!: boolean; //数据显示模式
  sheetShow: boolean = false; //sheetview
  sheetData: any = {
    sheetName: "",
    sheetOrder: 1,
    recycle: false,
    EventType: "Task",
  };
  sheetItems = [
    {
      label: "页签名称",
      type: "input",
      prop: "sheetName",
      model: "sheetName",
      col: 24,
    },
    {
      label: "序号",
      type: "input",
      inputType: "number",
      prop: "sheetOrder",
      model: "sheetOrder",
      col: 24,
    },
    {
      label: "循环执行",
      type: "radio",
      prop: "recycle",
      model: "recycle",
      children: [
        { value: false, text: "否" },
        { value: true, text: "是" },
      ],
      col: 24,
    },
    {
      label: "类型",
      type: "radio",
      prop: "EventType",
      model: "EventType",
      children: [
        { value: "Task", text: "任务" },
        { value: "Work", text: "工作反馈" },
        { value: "Meet", text: "会议" },
        { value: "Asset", text: "资产" },
        { value: "Field", text: "信息" },
      ],
      col: 24,
    },
  ];
  shfruleValidate: any = {
    sheetName: [
      { required: true, message: "页签名称不能为空", trigger: "blur" },
    ],
  };
  selectedSheet: string = "";
  sectionShow: boolean = false; //group view
  sectionData: any = { section: "", sectionOrder: 1 };
  sectionItems = [
    {
      label: "信息分组名称",
      type: "input",
      prop: "section",
      model: "section",
      col: 24,
    },
    {
      label: "序号",
      type: "input",
      inputType: "number",
      prop: "sectionOrder",
      model: "sectionOrder",
      col: 24,
    },
  ];
  stfruleValidate: any = {
    section: [
      { required: true, message: "信息分组名称不能为空", trigger: "blur" },
    ],
  };
  selectedSection: string = "";
  itemShow: boolean = false;
  ItemTypes: any = [
    {
      value: "input",
      text: "文本输入",
      describe: "",
      IData: [
        {
          label: "占位信息",
          type: "input",
          prop: "placeholder",
          model: "placeholder",
          col: 24,
        },
        {
          label: "信息单位",
          type: "input",
          prop: "unit",
          model: "unit",
          col: 12,
        },
        {
          label: "默认行数",
          type: "input",
          inputType: "number",
          prop: "inputRows",
          model: "inputRows",
          col: 12,
        },
        {
          label: "输入格式",
          type: "radio",
          prop: "inputType",
          model: "inputType",
          children: [
            { value: "text", text: "文本框" },
            { value: "textarea", text: "文本区" },
            { value: "url", text: "网页地址" },
            { value: "email", text: "邮电地址" },
            { value: "tel", text: "电话" },
          ],
          col: 24,
        },
      ],
    },
    {
      value: "number",
      text: "数字输入",
      describe: "",
      IData: [
        {
          label: "最大数",
          type: "input",
          inputType: "number",
          prop: "max",
          model: "max",
          col: 12,
        },
        {
          label: "最小数",
          type: "input",
          inputType: "number",
          prop: "min",
          model: "min",
          col: 12,
        },
        {
          label: "步长增量",
          type: "input",
          inputType: "number",
          prop: "step",
          model: "step",
          col: 12,
        },
        {
          label: "单位",
          type: "input",
          inputType: "text",
          prop: "unit",
          model: "unit",
          col: 12,
        },
      ],
    },
    {
      value: "datePicker",
      text: "日期选项",
      describe: "",
      IData: [
        {
          label: "格式",
          type: "radio",
          prop: "pickertype",
          model: "pickertype",
          children: [
            { value: "date", text: "日期" },
            { value: "daterange", text: "日期区间" },
            { value: "datetime", text: "日期时间" },
            { value: "datetimerange", text: "时间区间" },
          ],
          col: 24,
        },
      ],
    },
    {
      value: "select",
      text: "下拉选项",
      describe: "",
      IData: [
        {
          label: "选项字符串",
          type: "input",
          prop: "Soptions",
          model: "Soptions",
          placeholder: "1:选项一;2选项二;3选项三;",
          col: 24,
        },
      ],
    },
    {
      value: "radio",
      text: "单选",
      describe: "",
      IData: [
        {
          label: "选项字符串",
          type: "input",
          prop: "Soptions",
          model: "Soptions",
          placeholder: "1:选项一;2选项二;3选项三;",
          col: 24,
        },
      ],
    },
    {
      value: "checkbox",
      text: "复选",
      describe: "",
      IData: [
        {
          label: "选项字符串",
          type: "input",
          prop: "Soptions",
          model: "Soptions",
          placeholder: "1:选项一;2选项二;3选项三;",
          col: 24,
        },
      ],
    },
    { value: "textEditor", text: "富文本输入", describe: "", IData: [] },
    {
      value: "uploadFiles",
      text: "附件上传",
      describe: "",
      IData: [
        {
          label: "文件夹名",
          type: "input",
          prop: "paramsPath",
          model: "paramsPath",
          col: 12,
        },
        {
          label: "附件分组",
          type: "input",
          placeholder: "类型1,类型2,类型3",
          prop: "paramsgroups",
          model: "paramsgroups",
          col: 12,
        },
        {
          label: "附件大小",
          type: "input",
          inputType: "number",
          prop: "paramsmaxSize",
          model: "paramsmaxSize",
          slot: { btntext: "MB" },
          col: 12,
        },
      ],
    },
  ];
  itemInforData: any = {
    code: "",
    name: "",
    unit: "",
    orderNo: 1,
    col: 12,
    formItemType: "input",
    validate: 2,
    formType: { placeholder: "" },
  };
  itemproperties: any = [
    {
      label: "信息代码",
      type: "input",
      prop: "code",
      model: "code",
      col: 12,
    },
    {
      label: "信息名称",
      type: "input",
      prop: "name",
      model: "name",
      col: 12,
    },
    {
      label: "显示序号",
      type: "input",
      inputType: "number",
      prop: "orderNo",
      model: "orderNo",
      col: 8,
    },
    {
      label: "布局占位",
      type: "select",
      prop: "col",
      model: "col",
      children: [
        { value: 6, text: "四分之一" },
        { value: 8, text: "三分之一" },
        { value: 12, text: "二分之一" },
        { value: 24, text: "整行" },
      ],
      col: 16,
    },
    {
      label: "输入控件",
      type: "select",
      prop: "formItemType",
      model: "formItemType",
      children: this.ItemTypes,
      onChange: this.ItemTypeChange,
      col: 12,
    },
    {
      label: "是否必填",
      type: "radio",
      prop: "validate",
      model: "validate",
      children: [
        { value: 1, text: "是" },
        { value: 2, text: "否" },
      ],
      col: 12,
    },
  ];
  itemattributes: any = [];
  itfruleValidate: any = {
    code: [{ required: true, message: "信息代码不能为空", trigger: "blur" }],
    name: [{ required: true, message: "信息名称不能为空", trigger: "blur" }],
  };
  //#endregion
  //#region event
  mounted() {
    const container = document.getElementById(this.jsonEditBoxId);
    const options = {
      mode: "code", // tree，view，form，code，text
      onChange: this.jsonDataChange,
    };
    this.editor = new JSONEditor(container, options);
    this.setJsonData(this.JsonData);
  }
  setJsonData(JsonData) {
    //设置json数据
    if (Object.prototype.toString.call(JsonData) === "[object Array]") {
      JsonData.map((q) => {
        if (q.children) {
          q.children.map((s) => {
            s.items.map((it) => {
              it["Indentitys"] = {
                sheet: q.category,
                section: s.section,
                code: it.code,
              };
            });
            s.items.sort((a, b) => {
              return Number(a.orderNo) - Number(b.orderNo);
            });
          });
          q.children.sort((a, b) => {
            return Number(a.orderNo) - Number(b.orderNo);
          });
        }
      });
      JsonData.sort((a, b) => {
        return Number(a.orderNo) - Number(b.orderNo);
      });
    }
    this.JsonData = JsonData;
    this.editor.set(this.JsonData);
  }

  setData(data) {
    if (Object.prototype.toString.call(data) === "[object Array]") {
      data.map((q) => {
        if (q.children) {
          q.children.map((s) => {
            s.items.map((it) => {
              it["Indentitys"] = {
                sheet: q.category,
                section: s.section,
                code: it.code,
              };
            });
            s.items.sort((a, b) => {
              return Number(a.orderNo) - Number(b.orderNo);
            });
          });
          q.children.sort((a, b) => {
            return Number(a.orderNo) - Number(b.orderNo);
          });
        }
      });
      data.sort((a, b) => {
        return Number(a.orderNo) - Number(b.orderNo);
      });
    }
    this.editor.set(data);
  }

  getJsonValid() {
    //json
    let x = this.editor.validate();
    return x;
  }
  changeView() {
    if (this.DataStruct) {
      this.JsonData = this.editor.get();
    } else {
      this.editor.set(this.JsonData);
    }
    this.DataStruct = !this.DataStruct;
  }
  showAddSheet() {
    if (Object.prototype.toString.call(this.JsonData) === "[object Array]") {
      this.sheetShow = true;
    }
  }
  showAddSheetData() {
    this.ref("sheetform").validate((vd) => {
      if (vd) {
        if (
          !this.JsonData.some((itm) => {
            return itm.category == this.sheetData.sheetName;
          })
        ) {
          let JsonData = [
            {
              category: this.sheetData.sheetName,
              orderNo: Number(this.sheetData.sheetOrder),
              recycle: this.sheetData.recycle,
              EventType: this.sheetData.EventType,
              children: [],
            },
          ].concat(this.JsonData);
          JsonData.sort((a, b) => {
            return Number(a.orderNo) - Number(b.orderNo);
          });
          this.sheetShow = false;
          this.sheetData.sheetName = "";
          this.setJsonData(JsonData);
        } else {
          this.alert("页签【" + this.sheetData.sheetName + "】已经存在！");
        }
      }
    });
  }
  Removesheet(sheetname) {
    let JsonData = this.Baselinq.from(<any[]>this.JsonData)
      .where((f) => f.category != sheetname)
      .toArray();
    this.setJsonData(JsonData);
  }
  showAddSection(sheetname) {
    this.sectionShow = true;
    this.selectedSheet = sheetname;
  }
  showAddSheetSectionData() {
    this.ref("sectionform").validate((vd) => {
      if (vd) {
        this.JsonData.map((q) => {
          if (q.category == this.selectedSheet) {
            if (
              !q.children.some((itm) => {
                return itm.section == this.sectionData.section;
              })
            ) {
              let JsonData = [
                {
                  section: this.sectionData.section,
                  orderNo: Number(this.sectionData.sectionOrder),
                  items: [],
                },
              ].concat(q.children);
              this.sectionShow = false;
              this.sectionData.section = "";
              q.children = JsonData;
              q.children.sort((a, b) => {
                return Number(a.orderNo) - Number(b.orderNo);
              });
            } else {
              this.alert(
                "信息分组【" + this.sectionData.section + "】已经存在！"
              );
            }
          }
        });
        this.setJsonData(this.JsonData);
      }
    });
  }
  RemoveSection(sheetname, section) {
    this.JsonData.map((q) => {
      if (q.category == sheetname) {
        let JsonData = this.Baselinq.from(<any[]>q.children)
          .where((f) => f.section != section)
          .toArray();
        q.children = JsonData;
      }
    });
    this.setJsonData(this.JsonData);
  }
  showAddItemInfo(sheetname, section) {
    this.itemShow = true;
    this.selectedSheet = sheetname;
    this.selectedSection = section;
    this.itemattributes = this.ItemTypes[0].IData;
  }
  ItemTypeChange(event, item) {
    let xtype = this.Baselinq.from(<any[]>this.ItemTypes)
      .where((f) => f.value == event)
      .toArray();
    if (xtype.length == 1) {
      this.itemattributes = xtype[0].IData;
      if (this.itemattributes.length > 0) {
        let typs: any = {};
        this.itemattributes.map((tim) => {
          if (event == "input") {
            if ((tim.prop = "inputType")) typs[tim.prop] = "text";
            else if ((tim.prop = "inputRows")) typs[tim.prop] = 3;
            else typs[tim.prop] = "";
          } else typs[tim.prop] = "";
        });
        this.$set(this.itemInforData, "formType", typs);
      } else {
        this.$set(this.itemInforData, "formType", {});
      }
    } else {
      this.itemattributes = [];
    }
    // console.log(this.itemInforData,"8****");
  }
  showAddSectionItemData() {
    let nitem: any = {
      code: this.itemInforData.code,
      name: this.itemInforData.name,
      value: "",
      unit: this.itemInforData.unit,
      orderNo: Number(this.itemInforData.orderNo),
      col: this.itemInforData.col,
      validate: {
        required: this.itemInforData.validate == 1 ? "true" : "false",
        message: "不能为空",
        trigger: "blur",
        type: "string",
      },
      formItem: this.assiginObj(this.itemInforData.formType, {
        type: this.itemInforData.formItemType,
      }),
    };
    if (
      this.itemInforData.formItemType == "select" ||
      this.itemInforData.formItemType == "radio" ||
      this.itemInforData.formItemType == "checkbox"
    ) {
      nitem.formItem = { type: this.itemInforData.formItemType, children: [] };
      if (this.itemInforData.formType.Soptions.indexOf(":") == -1) {
        alert("选项配置字符串不正确");
        return;
      }
      let xitems = this.itemInforData.formType.Soptions.split(";");
      xitems.map((opt) => {
        if (opt.indexOf(":") != -1) {
          let optim = opt.split(":");
          nitem.formItem.children.push({
            value: optim[0],
            text: optim[1],
          });
        }
      });
      nitem.validate.type = "number";
    } else if (this.itemInforData.formItemType == "uploadFiles") {
      if (this.itemInforData.formType.paramsPath == "") {
        this.itemInforData.formType.paramsPath = "sysDefault";
      }
      if (this.itemInforData.formType.paramsmaxSize < 0) {
        this.itemInforData.formType.paramsmaxSize = 10;
      }
      let filecato: any = [];
      if (this.itemInforData.formType.paramsgroups == "") {
        filecato = ["默认01"];
      } else {
        filecato = this.itemInforData.formType.paramsgroups.split(",");
      }
      nitem.formItem = {
        type: this.itemInforData.formItemType,
        params: {
          Path: "/" + this.itemInforData.formType.paramsPath,
          groups: filecato,
          maxSize: Number(this.itemInforData.formType.paramsmaxSize) * 1024,
        },
      };
    } else if (this.itemInforData.formItemType == "datePicker") {
      nitem.formItem = {
        type: this.itemInforData.formItemType,
        pickertype:
          this.itemInforData.formType.pickertype == ""
            ? "date"
            : this.itemInforData.formType.pickertype,
      };
      nitem.validate.type = "date";
      if (
        this.itemInforData.formType.pickertype == "daterange" ||
        this.itemInforData.formType.pickertype == "datetimerange"
      )
        nitem.validate.type = "array";
    } else if (this.itemInforData.formItemType == "number") {
      if (nitem.formItem.max == "") {
        delete nitem.formItem.max;
      }
      if (nitem.formItem.min == "") {
        delete nitem.formItem.min;
      }
    }
    this.JsonData.map((q) => {
      if (q.category == this.selectedSheet) {
        q.children.map((s) => {
          if (s.section == this.selectedSection) {
            if (
              !s.items.some((itm) => {
                return itm.code == nitem.code;
              })
            ) {
              s.items = [nitem].concat(s.items);
              s.items.sort((a, b) => {
                return Number(a.orderNo) - Number(b.orderNo);
              });
            }
          }
        });
      }
    });
    this.setJsonData(this.JsonData);
    this.itemShow = false;
    this.itemInforData = {
      code: "",
      name: "",
      unit: "",
      orderNo: 1,
      col: 12,
      formItemType: "input",
      validate: 2,
      formType: {},
    };
  }
  RemoveSectionItemData(tag) {
    alert();
  }
  //#endregion
  //#region method
  getJsonData() {
    //获取配置好的json数据
    let jsonData = this.editor.get();
    return jsonData;
  }
  getData() {
    return this.getJsonData();
  }
  jsonDataChange() {
    let jsd = this.editor.get();
    this.$emit("jsonDataChange", jsd);
  }
  //#endregion
}
